import dayjs from 'dayjs';
import { TFunction } from 'i18next';
import { DateElement } from '../types/basket-types';

export function setTimeOnDateElement(date: DateElement, time: string | undefined | null): string | undefined | null {
  if (!time) {
    return date.collection?.date;
  }
  const d = dayjs(date.collection?.date);
  const [hours, minutes] = time.split(':').map(Number);
  const timedDate = d.hour(hours).minute(minutes).second(0).millisecond(0);
  return timedDate.toISOString();
}

export function isSameDay(date: DateElement, referenceDate: string | null | undefined) {
  if (!referenceDate) {
    return false;
  }
  return dayjs(date.collection?.date).isSame(dayjs(referenceDate), 'day');
}

export const formateDate = (t: TFunction<[string], undefined>, date: Date, cutoff?: Date | null) => {
  if (!date) return '';

  const cutoffStr = cutoff ? dayjs(cutoff).format('ddd, Do MMMM HH:mm') : null;

  const collectionToday = dayjs(date).isSame(dayjs(), 'day');
  if (collectionToday) {
    return t(cutoffStr ? 'COLLECTION_DATE_TODAY_IF_BOOKED' : 'COLLECTION_DATE_TODAY', {
      defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
      date: 'Today',
      cutoff: cutoffStr
    });
  }

  const collectionTomorrow = dayjs(date).isSame(dayjs().add(1, 'day'), 'day');
  if (collectionTomorrow) {
    return t(cutoffStr ? 'COLLECTION_DATE_TOMORROW_IF_BOOKED' : 'COLLECTION_DATE_TOMORROW', {
      defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
      date: 'Tomorrow',
      cutoff: cutoffStr
    });
  }

  return t(cutoffStr ? 'COLLECTION_DATE_IF_BOOKED' : 'COLLECTION_DATE', {
    defaultValue: cutoffStr ? '{{date}} if booked before {{cutoff}}' : '{{date}}',
    date: dayjs(date).format('ddd, Do MMMM'),
    cutoff: cutoffStr
  });
};
